import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SurveyDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md"
      scroll="paper"
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Application Feedback Survey
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <iframe
          id="JotForm"
          title="Application Survey"
          src="https://form.jotform.com/252643931825057"
          frameBorder="0"
          style={{ minWidth: "100%", maxWidth: "100%", height: "600px", border: "none" }}
          scrolling="yes"
        />
      </DialogContent>
    </Dialog>
  );
};

export default SurveyDialog;
